/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { OverflowItem, assertSlots } from '@fluentui/react-components';
import type { ReferenceOverflowButtonState, ReferenceOverflowButtonSlots } from './ReferenceOverflowButton.types';
import type { JSXElement } from '@fluentui/react-utilities';

/**
 * Render the final JSX of ReferenceOverflowButton
 */
export const renderReferenceOverflowButton_unstable = (state: ReferenceOverflowButtonState): JSXElement | null => {
  assertSlots<ReferenceOverflowButtonSlots>(state);
  const { id, shouldRenderOverflowButton } = state;

  return shouldRenderOverflowButton ? (
    <OverflowItem key={id} id={id} priority={1}>
      <state.root />
    </OverflowItem>
  ) : null;
};
